import React from 'react';
import { history } from '../store';
import '../styles/QRsAdminView.css'

class CustomerList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterOpen: true,
      filters: {
        customer: '',
        country: '',
      },
    };
    this.toggleFilter = this.toggleFilter.bind(this)
  }

  goTo(id, e) {
    history.push(`/customers/${id}`);
  }

  toggleFilter() {
    this.setState(prev => ({ filterOpen: !prev.filterOpen }))
  }

  handleFilterChange(filterKey, value) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [filterKey]: value,
      },
    }));
  }

  getSAPConversion(model) {
    switch (model) {
      case 'CV': return 'COMISION VENTA';
      case 'VC': return 'VENTAS CONTADO';
      default: return model || '—';
    }
  }

  render() {
    const { filters, filterOpen } = this.state;
    const { customers } = this.props;

    const filteredCustomers = customers.filter(customer => {
      const { customer: customerFilter, country: countryFilter } = filters;
      if (customerFilter && (!customer.Fullname || !customer.Fullname.toLowerCase().includes(customerFilter.toLowerCase()))) return false;
      if (countryFilter && (!customer.Country || !customer.Country.toLowerCase().includes(countryFilter.toLowerCase()))) return false;
      return true;
    });

    return (
      <div>
        {/* Collapsible Filter Panel */}
        <div className="qrs-admin-filter-card">
          <div className="qrs-admin-filter-header" onClick={this.toggleFilter}>
            <h3><i className="fas fa-filter"></i> Filtros</h3>
            <i className={`fas fa-chevron-down toggle-icon ${filterOpen ? 'open' : ''}`}></i>
          </div>
          {filterOpen && (
            <div className="qrs-admin-filter-body">
              <div className="filter-grid">
                <div className="filter-group">
                  <label>Cliente</label>
                  <input
                    type="text"
                    placeholder="Buscar por cliente..."
                    value={filters.customer}
                    onChange={e => this.handleFilterChange('customer', e.target.value)}
                  />
                </div>
                <div className="filter-group">
                  <label>País</label>
                  <input
                    type="text"
                    placeholder="Buscar por país..."
                    value={filters.country}
                    onChange={e => this.handleFilterChange('country', e.target.value)}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Column Headers */}
        <div className="qrs-admin-list-header">
          <div className="qrs-header-col col-customer">Nombre completo</div>
          <div className="qrs-header-col col-id">País</div>
          <div className="qrs-header-col col-payments">SAP</div>
          <div className="qrs-header-col col-payments">Teléfono</div>
          <div className="qrs-header-col col-payments">E-Mail</div>
        </div>

        {/* Cards */}
        <div className="qrs-admin-list">
          {filteredCustomers.length > 0 ? (
            filteredCustomers
              .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
              .map(customer => (
                <div key={customer._id} className="qrs-admin-card" onClick={e => this.goTo(customer._id, e)}>
                  <div className="qrs-admin-row">
                    <div className="qrs-admin-status-bar ENABLED"></div>
                    <div className="qrs-admin-content">
                      <div className="qrs-admin-machine-customer">
                        <div className="qrs-admin-customer-name">{customer.Fullname}</div>
                      </div>
                      <div className="qrs-admin-machine-id">
                        <div className="qrs-admin-sub">{customer.Country || '—'}</div>
                      </div>
                      <div className="qrs-admin-machine-payments">
                        <div className="qrs-admin-sub">{this.getSAPConversion(customer.SAP?.Model)}</div>
                      </div>
                      <div className="qrs-admin-machine-payments">
                        <div className="qrs-admin-sub">{customer.Phone || '—'}</div>
                      </div>
                      <div className="qrs-admin-machine-payments">
                        <div className="qrs-admin-sub">{customer.Email || '—'}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
          ) : (
            <div className="qrs-admin-empty">
              <i className="fas fa-users"></i>
              <p>No se encontraron clientes</p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CustomerList;